











import {Component, Prop, Watch, Vue} from 'vue-property-decorator';

@Component
export default class Notice extends Vue {
  @Prop() private messageList!: any[];
}
